import { loadRoutesFromModules } from '@radical/utils'
import { RouteRecordRaw } from 'vue-router'
import {
  ROOT_ROUTE,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  LOGIN_ROUTE,
} from './basic'

const routeModuleRecord = import.meta.glob('./modules/**/*.ts', { eager: true })
// @ts-ignore
const routeModules: RouteRecordRaw[] = loadRoutesFromModules(routeModuleRecord)

export const asyncRoutes = routeModules

// Keep PAGE_NOT_FOUND_ROUTE at the root level as it should catch all unmatched routes
export const BasicRoutes = [
  ...routeModules,
  ROOT_ROUTE,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  LOGIN_ROUTE,
]
